import { useContext } from 'react';
import { ModalOverLayContext } from '~/component/Context/ModalOverLayProvider';
import classNames from 'classnames/bind';

import styles from './CreatePostPage.module.scss';
import CreatePost from '~/component/CreatePost';
import CreateProject from '~/component/CreateProject';
import useMeta from '~/hooks/useMeta';
import CreateTips from '~/component/CreateTips/CreateTips';
import CreateTipType from '~/component/CreateTipType';
import CreateProjectType from '~/component/CreateProjectType';
import { useNavigate } from 'react-router-dom';
import routes from '~/configs';

const cx = classNames.bind(styles);

function CreatePostPage() {
  const { setModalComponentContent } = useContext(ModalOverLayContext);
  const navigate = useNavigate();
  
  useMeta({
    title: 'Đăng Bài Viết - Blog Cá Nhân của Ngô Gia Quyến',
    description:
      'Trang đăng bài viết cho blog cá nhân của tôi, nơi tôi chia sẻ những suy nghĩ, kiến thức, và kinh nghiệm trong các lĩnh vực yêu thích.',
    keywords: 'blog, đăng bài viết, chia sẻ kinh nghiệm, viết blog, tư duy sáng tạo, kiến thức',
    author: 'Ngô Gia Quyến',
    url: 'https://ngogiaquyen.id.vn/create-post',
  });

  return (
    <div className={cx('wrapper')}>
      <button className={cx('create-post-btn')} onClick={() => setModalComponentContent(<CreatePost />)}>
        Create Post
      </button>
      <button className={cx('create-post-btn')} onClick={() => setModalComponentContent(<CreateProjectType />)}>
        Create Projects Type
      </button>
      <button className={cx('create-post-btn')} onClick={() =>  navigate(routes.projectTypes)}>
        Project Type Manager
      </button>
      <button className={cx('create-post-btn')} onClick={() => setModalComponentContent(<CreateProject />)}>
        Create Projects
      </button>
      <button className={cx('create-post-btn')} onClick={() => setModalComponentContent(<CreateTipType />)}>
        Create Tip type
      </button>
      <button className={cx('create-post-btn')} onClick={() => setModalComponentContent(<CreateTips />)}>
        Create Tips
      </button>
    </div>
  );
}

export default CreatePostPage;
